module.exports = __webpack_public_path__ + "media/images/crossSectionGray-ee4c0c65e2e7bc500fc46ce5e61086f4.svg";